import React from 'react'
import { connect } from 'react-redux'
import { editSets } from "../../actions/settings"
import Select from 'react-select'
import DeleteConfirmation from '../ui/DeleteConfirmation'
import SettingsItemForm from './SettingsItemForm'

class SetsSrvmItem extends SettingsItemForm {

  modelName = 'srvm'

  render() {
    const { data } = this.props;
    const { data: nData, errors } = this.state;

    const delConf = this.state.delConf ?
      <DeleteConfirmation
        onDelete={this.deleteItem}
        onCancel={this.toggleDelConf}
      />
      :
      '';

    var srvmTypesOpt = [
      {
        value: 0,
        label: '(пусто)'
      },
      {
        value: 1,
        label: 'Постоянные расходы'
      },
      {
        value: 2,
        label: 'Условно-постоянный расходы'
      },
      {
        value: 3,
        label: 'Условно-переменные расходы'
      },
      {
        value: 4,
        label: 'Капитальные вложения'
      },
    ];

    const srvmType = srvmTypesOpt.find(el => el.value === data.srvm_type).label;

    if(this.state.editing){
      return(
        <tr>
          <td>
          {delConf}
            <div className="form-group">
              <input type="text"
                className="form-control"
                value={nData.srvm_desc}
                name="srvm_desc"
                onChange={this.updateInput}
                placeholder="Название"
                autoFocus
              />
            </div>
            <div className="form-inline">
              <button  type="button" className="btn btn-success"
                onClick={this.saveItem} title="Сохранить">
                <span className="glyphicon glyphicon-save"></span>
              </button>{" "}
              <button type="button" className="btn btn-default"
                onClick={this.cancelEditing} title="Отменить">
                <span className="glyphicon glyphicon-remove"></span>
              </button>{" "}
              <button type="button" className="btn btn-danger"
                onClick={this.toggleDelConf} title="Удалить">
                <span className="glyphicon glyphicon-trash"></span>
              </button>
            </div>
            {errors.form && <div className="alert alert-danger">{errors.form}</div>}
          </td>
          <td>
            <Select
              clearable={false}
              options={srvmTypesOpt}
              value={nData.srvm_type}
              onChange={e => this.updateSelect(e,'srvm_type')}
              placeholder="Тип для отчетов"
            />
          </td>
        </tr>
      );
    }
    else{
      return (
        <tr onClick={this.startEditing}>
          <td>{data.srvm_desc}</td>
          <td>{srvmType}</td>
        </tr>
      );
    }

  }
}

export default connect(null, { editSets })(SetsSrvmItem);



// WEBPACK FOOTER //
// ./src/components/settings/SetsSrvmItem.js